// PaymentSummary.js
import React from 'react';
import '../styles/PaymentSummary.css';

const PaymentSummary = ({
  totalAmount, // 合計
  salesList, // 販売商品リスト
  sale_type, // 免税判定
  cashGiven, // 預り金額(現金)
  cardGiven, // 預り金額(カード)
  changeinfo,// おつり
  taxRate, // 消費税率
  taxFreeMode,
  calculateTax, // 税額の合計
  setCashGiven,
  setCardGiven,
  setChange,
}) => {
  const total = salesList.reduce((sum, item) => sum + item.subtotal, 0);
  const totalTax = calculateTax(totalAmount, taxRate); // 税額の合計
  const totalDiscount = salesList.reduce((sum, item) => sum + item.discount, 0);
  const totalWithTax = totalAmount + totalTax; // 税込み合計
  const isTaxExempt = sale_type === 'tax_exempt';

  // ★従来方式の免税だけ消費税を取らない
  const isLegacyTaxExempt =
    isTaxExempt && taxFreeMode === "legacy";

  const Finalpaymentamount =
    isLegacyTaxExempt
      ? totalAmount
      : totalWithTax;
  const totalGiven = cashGiven + cardGiven ;

  
  // 支払いをキャンセルする関数
  const handlePaymentCancel = () => {
    setCashGiven(0);
    setCardGiven(0);
    setChange(0);
  };
  


  return (
    <div className="paymentSummary">
      {/* 商品点数と小計 */}
      <div className="paymentSummary__section">
        <div>
          <span className="paymentSummary__fontnormal">商品点数: {salesList.length}</span>
        </div>
        <div>
          <span className="paymentSummary__fontnormal">小計: ¥{total.toLocaleString()}</span>
          <div className="paymentSummary__tax">
          <span>値引き: ¥{totalDiscount}</span>
          </div>
        </div>     
        <div className="paymentSummary__separator" />
        {/* お支払金額 (免税ならTAX-FREEを表示) */}
        <div className="paymentSummary__separator_box">
          <span className="paymentSummary__fontlarge2">
            お支払金額
          </span>
          <span className="paymentSummary__fontlarge2">
            <span className={`tax-free ${isTaxExempt ? "visible" : ""}`}>
              (TAX-FREE)
            </span>
            <span className="paymentred">
              ¥{Finalpaymentamount.toLocaleString()}
            </span>
          </span>
        </div>
        {/* 消費税 */}
        <div className="paymentSummary__tax">
          <span>
            消費税: ¥
            {isLegacyTaxExempt
              ? 0
              : totalTax.toLocaleString()}
          </span>
        </div>
      </div>
      
            
      {/* 残額 */}
      <div className="paymentSummary__section">
        <div>
          <span className="paymentSummary__fontlarge2">お預かり金額
            <button className="paymentSummary__clearButton" onClick={handlePaymentCancel}>
              クリア
            </button>
          </span>
          {cardGiven > 0 ? (
            <span className="payment-type visible">キャッシュレス</span>
          ) : cashGiven > 0 ? (
            <span className="payment-type visible">現金</span>
          ) : (
            <span className="payment-type">&nbsp;</span>
          )}
        </div>
        <span className="paymentSummary__fontlarge"> ¥{totalGiven.toLocaleString()}</span>
          <div className="paymentSummary__remainingArea">
            {totalGiven > 0 && Finalpaymentamount - totalGiven > 0 && (
              <span className="shortage">
                不足額: ¥{(Finalpaymentamount - totalGiven).toLocaleString()}
              </span>
            )}
          </div>
      </div>
      
      
      {/* お釣り */}
      <div className="paymentSummary__section paymentSummary__changeSection">
        <div>
          <span className="paymentSummary__fontlarge2">おつり</span>
          <span className="paymentSummary__fontlarge3">{changeinfo}</span>
        </div>
      </div>
    </div>
  );
};

export default PaymentSummary;
